import { isEmpty } from 'lodash';
import { RootScopeEvents } from '../../../../../common/services/root-scope-types';
import { MediaIssueType, } from '../../../tokbox/publisher-media-watcher.class';
export class AutoMediaDisabler {
    constructor(VideoProviderFactory, $rootScope) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.$rootScope = $rootScope;
        this.state = { audio: false, video: false };
    }
    get activeProvider() {
        return this.VideoProviderFactory.activeProvider;
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.MEDIA_BROKEN, (_e, data) => {
            this.onMediaBroken(data);
        });
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.PUBLISHER_SUCCESS, (_e, ui) => {
            this.onMediaSuccess(ui);
        });
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.TOGGLE_MEDIA, (_e, changes) => {
            this.onToggleMedia(changes);
        });
    }
    onMediaBroken(data) {
        if (data.mediaIssueType === MediaIssueType.mediaBroken) {
            this.updateState({ audio: true, video: true });
        }
        else if (data.mediaIssueType === MediaIssueType.audioBroken) {
            this.updateState({ audio: true });
        }
        else if (data.mediaIssueType === MediaIssueType.videoBroken) {
            this.updateState({ video: true });
        }
    }
    updateState(stateChanges) {
        const beforeState = { ...this.state };
        this.state = { ...this.state, ...stateChanges };
        const afterState = { ...this.state };
        const changes = this.getStateDiff(beforeState, afterState);
        if (!isEmpty(changes))
            this.onStateChange(changes);
    }
    onStateChange(changes) {
        if (changes.audio)
            this.activeProvider.togglePublishersAudio(false);
        if (changes.video)
            this.activeProvider.togglePublishersVideo(false);
        this.$rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.AUTO_DISABLE_MEDIA, changes);
    }
    onMediaSuccess(ui) {
        if (ui.hasAudio)
            this.state.audio = false;
        if (ui.hasVideo)
            this.state.video = false;
    }
    onToggleMedia(changes) {
        const isAudioEnabledAfterAutoDisabling = this.state.audio && changes.hasAudio;
        const isVideoEnabledAfterAutoDisabling = this.state.video && changes.hasVideo;
        if (isAudioEnabledAfterAutoDisabling || isVideoEnabledAfterAutoDisabling) {
            this.activeProvider.initPublisher();
        }
    }
    getStateDiff(prevState, state) {
        // TODO use getObjectDiff;
        const changes = {};
        if (!prevState.video && state.video)
            changes.video = true;
        if (!prevState.audio && state.audio)
            changes.audio = true;
        return changes;
    }
}
